import { render } from "./HomeDiferenciais.vue?vue&type=template&id=b54d04c6&scoped=true"
import script from "./HomeDiferenciais.vue?vue&type=script&lang=js"
export * from "./HomeDiferenciais.vue?vue&type=script&lang=js"

import "./HomeDiferenciais.vue?vue&type=style&index=0&id=b54d04c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54d04c6"]])

export default __exports__